import {MenuOption, PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const"
import Task from "../../../../model2/task/task"


export type Props = {
    task            : Task

    hidePopover?    : func
}

export function taskMore_initSaveAsTemplate(props: Props, menuOptions:MenuOption[]) {

    const project           = gd.session.projects.get(props.task.projectId ? props.task.projectId : props.task.parentId);
    const isTemplate        = project ? project.isTemplate : false;

    const onClickSaveAsTemplate = () => {
        props.hidePopover?.()
        gd.modals.task.saveAsTemplate(props.task)
    }

    const onClickPro = () => {
        gd.modals.other.upgradeToPro(gd.companyId)
    }

    if (!isTemplate) {
        menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})
        menuOptions.push({
            icon            : "i5-templates",
            label           : "Save as template",
            onClick         : onClickSaveAsTemplate,
            onClickUpgrade  : onClickPro,
            isPro           : !gd.company.license.isPro
        })
    }
}